import { type FC, type ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * Single-line ellipsis truncation with a tooltip showing the full value.
 * `min-w-0` is baked in to stop a long value blowing out a flex row.
 * `children`, if given, replaces `text` in the truncated line; `text` fills the tooltip.
 */
export const TruncatedText: FC<{
  text: string;
  className?: string;
  tooltipClassName?: string;
  dataCy?: string;
  children?: ReactNode;
}> = ({ text, className, tooltipClassName, dataCy, children }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <div className={cn('min-w-0 truncate', className)} data-cy={dataCy}>
        {children ?? text}
      </div>
    </TooltipTrigger>
    <TooltipPortal>
      <TooltipContent className={cn('max-w-64 break-all', tooltipClassName)}>{text}</TooltipContent>
    </TooltipPortal>
  </Tooltip>
);
